import { errorConstants } from '../constants';

const initialState = {
    open: false,
    message: "",
    code: 200,
    tokenExpired: false
}

export function error(state = initialState, action) {
  switch (action.type) {
    case errorConstants.UPDATE:
      return {
        ...state,
        open: action.error.open,
        code: action.error.code,
        message: action.error.message,
        tokenExpired: state.tokenExpired || action.error.tokenExpired
      };
    case errorConstants.RESET:
      return {
        ...state,
        ...action.error
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/errorDisplay.reducer.js